export default "__VITE_ASSET__3a5df675__"